<template>
  <div class="loginDialog">
    <div class="frombox">
      <Icon class="closeBtn" type="ios-close" @click="handleClose"></Icon>
      <div v-if="logonchangeflag">
        <div class="fromtop"  @click="changelogintype('wx')" @mouseenter="changeImageSrc('hover')"
             @mouseleave="changeImageSrc('nohover')">
          <img
            style="height: 40px; width: 40px"
            :src="imgsrc1"
            alt=""
          />
          <div class="erweimaris">
            二维码登录
          </div>
        </div>

        <div class="frombot">
          <p style="font-size: 20px; color: #17233D; line-height: 20px; text-align: center; margin-top: 24px">学生登录注册</p>

          <div class="iptbox" style="margin-top: 40px">
            <Form
              ref="loginForm"
              :model="form"
              :rules="rules"
              @keydown.enter.native="handleSubmit"
            >
              <FormItem prop="phone">
                <Input
                  v-if="!isChinaTaiWan"
                  class="phone_input"
                  v-model="form.phone"
                  placeholder="请输入手机号"
                  @input="checkInfo"
                />
                <Input v-else v-model="form.phone" placeholder="请输入手机号" class="my_input" @input="checkInfo">
                  <Select v-model="phone_type" slot="prepend" style="width: 78px" class="type_select" @on-change="handlePhoneTypeChange">
                    <Option value="86" label="+86">
                      <span>中国大陆</span>
                      <span>+86</span>
                    </Option>
                    <Option value="886" label="+886">
                      <span>中国台湾</span>
                      <span>+886</span>
                    </Option>
                  </Select>
                </Input>
              </FormItem>
              <FormItem prop="smsCode" class="sms-wrapper">
                <Input
                  v-model="form.smsCode"
                  placeholder="请输入短信验证码"
                  :maxlength="6"
                />
                <span
                  v-if="isShowGetCode"
                  class="identiCode"
                  :style="{color: fontColor ? '#c5c8ce' : '#1477EF'}"
                  @click="getIdentifyCode"
                >获取验证码</span
                >
                <span v-else class="identiCode cancel-pointer"
                >{{ countdown }}s后可重试</span
                >
              </FormItem>
            </Form>

            <p class="duxinp">使用手机验证码即可直接登录</p>
            <div class="subnitBtn" @click="handleSubmit">登录/注册</div>
          </div>
        </div>
      </div>

      <div v-if="!logonchangeflag">
        <div class="fromtop" @click="changelogintype('phone')" @mouseenter="changeImageSrc2('hover')"
             @mouseleave="changeImageSrc2('nohover')">
          <img
            style="height: 40px; width: 40px"
            :src="imgsrc2"
            alt=""
          />
          <div class="erweimaris">
            手机号登录
          </div>
        </div>

        <div class="frombot" style="text-align: center">
          <p style="font-size: 20px; color: #17233D; line-height: 20px; text-align: center">学生登录</p>

          <div style="text-align: center; position: relative; display: flex; flex-direction: column; align-items: center">
            <p style="font-size: 14px;color: #515A6E; line-height: 19px; margin-top: 40px;">请使用微信扫描二维码</p>
<!--            <img-->
<!--              ref="imgmask"-->
<!--              v-show="!loadingflag"-->
<!--              style="height: 240px; width: 240px; margin: 24px 0 10px 0"-->
<!--              :src="this.wxloginimg"-->
<!--              alt=""-->
<!--            />-->
            <div class="img-box" :style="{ background: 'url(' + wxloginimg + ') center center no-repeat'}">
              <div v-if="maskflag" class="maskdiv">
                <img class="imgs" src="@/assets/shuaxin.png" alt="">
                <span class="text" style="margin-bottom: 20px">二维码失效</span>
                <Button type="primary" class="submit" @click="resetCode">点击刷新</Button>
              </div>
              <img v-if="siteType != 1" v-show="!loadingflag" :src="siteType == 3 ? logoImage : codeImgBase64" alt="">
              <Spin
                      v-show="loadingflag"
                      size="large"
                      style="width: 240px; height: 240px; display: flex; justify-content: center; align-items: center"
              ></Spin>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="errorModal" footer-hide class="invoiceModal" :width="542">
      <h4>{{ errorMsg }}</h4>
      <div><img :src="company_concat_qr_code_url" alt="" /></div>
      <p>微信扫码联系客服</p>
    </Modal>
  </div>
</template>

<script>
  import {
    getwximg,
    getloginstatus,
    sendcode,
    stulogin,
    get_detail,
    getcommon
  } from "@/api/request.js";
  import { getsiteInfo, getcominfo } from '@/api/indexPage.js'
  import {eventBus} from '@/utils/eventBus'

  import Cookies from "js-cookie";
  import axios from 'axios'
  const error_code_map = {
    '1001': 'TCaptcha.js 加载错误',
    '1002': '调用 show 方法超时',
    '1003': '中间 js 加载超时',
    '1004': '中间 js 加载错误',
    '1005': '中间 js 运行错误',
    '1006': '拉取验证码配置错误/超时',
    '1007': 'iframe 加载超时',
    '1008': 'iframe 加载错误',
    '1009': 'jquery 加载错误',
    '1010': '滑块 js 加载错误',
    '1011': '滑块 js 运行错误',
    '1012': '刷新连续错误3次',
    '1013': '验证网络连续错误3次'
  }
  export default {
    name: "Login",
    props: {
      isJump: { // 1:我的简历， 2： 技能点击
        type: String,
        default: false
      },
      videoDetailUrl: {
        type: String
      },
      siteType:{
       default: ''  // //1：主站；2：学校；3：渠道
      },
      chanelbadge:{
        type: String
      },
      resumeTemplateId: {
        type: String
      }
    },
    data() {
      const validatePass = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入验证码"));
        } else {
          callback();
        }
      };
      const validateUser = (rule, value, callback) => {
        if (value === '') {
          callback(new Error("请输入手机号"));
        } else if(this.isChinaTaiWan) {
          if(this.phone_type == '86') {
            if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error("请输入正确的手机号"));
            }else {
              callback();
            }
          }else {
            if (!/^[0]?9\d{8}$/.test(value)) {
              callback(new Error("请输入正确的手机号"));
            }else {
              callback();
            }
          }
        } else {
          if (!/^1[3456789]\d{9}$/.test(value)) {
            callback(new Error("请输入正确的手机号"));
          }else {
            callback();
          }
        }
      };
      return {
        value: "",
        value11: "",

        countdown: 60,

        imgsrc1:require("@/assets/code_nor.png"),
        imgsrc2:require("@/assets/phone_nor.png"),
        img3:require("@/assets/main-bys.jpg"),
        isShowGetCode: true,

        form: {
          phone: "",
          smsCode: "",
        },

        loadingflag: true,

        wxloginimg: "",
        maskflag: false,

        logonchangeflag: false,

        rules: {
          phone: [{ validator: validateUser, trigger: "blur" }],
          smsCode: [{ validator: validatePass, trigger: "blur" }],
        },
        fontColor: true,
        codeImgBase64: '',
        logoImage:'',
        isChinaTaiWan: false,
        phone_type: '86',
        errorModal: false,
        errorMsg: '',
        company_concat_qr_code_url: ''
      };
    },

    created() {
      this.getwximg();
      this.getcominfos()
      window.isJumpFlag = true;
      if(this.siteType == 1 ){
        // this.codeImgBase64 = this.img3
      }else if(this.siteType == 3){
        this.logoImage = this.chanelbadge
        console.log('this.logoImage====== ',this.logoImage)
      }else{

        this.codeImgBase64 = JSON.parse(sessionStorage.getItem('schoolIcon'));
      }
      getsiteInfo().then(res => {
        console.log('================================', res)
        if(res.apiStatus) {
          this.isChinaTaiWan = res.is_taiban == 1 ? true : false
        }
      })
    },


    methods: {
      handlePhoneTypeChange() {
        console.log('this.$refs[\'loginForm\']', this.$refs['loginForm'])
        this.$refs['loginForm'].validateField('phone')
        this.checkInfo()
      },
      checkInfo() {
        if(this.isChinaTaiWan) {
          if(this.phone_type == '86') {
            if(/^1[3456789]\d{9}$/.test(this.form.phone)) {
              this.fontColor = false
              return
            }
            this.fontColor = true
          }else {
            if(/^[0]?9\d{8}$/.test(this.form.phone)) {
              this.fontColor = false
              return
            }
            this.fontColor = true
          }
        }else {
          if(/^1[3456789]\d{9}$/.test(this.form.phone)) {
            this.fontColor = false
            return
          }
          this.fontColor = true
        }

      },
      clearCookieData() {
        Cookies.remove('user_name')
        Cookies.remove('user_school')
        Cookies.remove('user_type')
        Cookies.remove('strategy')
        Cookies.remove('com_key_user')

        Cookies.remove('channel_userid')
        Cookies.remove('channel_channel_name')
      },
      handleClose() {
        this.$emit('closeClick')
      },
      changeImageSrc(key) {
        switch (key) {
          case "hover":
            this.imgsrc1 = require("@/assets/code_sel.png");
            break;
          case "nohover":
            this.imgsrc1 = require("@/assets/code_nor.png");
            break;
        }
      },

      changeImageSrc2(key) {
        switch (key) {
          case "hover":
            this.imgsrc2 = require("@/assets/phone_sel.png");
            break;
          case "nohover":
            this.imgsrc2 = require("@/assets/phone_nor.png");
            break;
        }
      },
      async handleSubmit() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            let data = {
              phone: this.isChinaTaiWan && this.phone_type == '886' ? this.phone_type + this.form.phone : this.form.phone,
              smsCode: this.form.smsCode,
            };
            stulogin(data).then(async (res) => {
              if (res.user_id) {
                // debugger

                this.clearCookieData()
                this.$Message.success("登录成功");
                Cookies.set("user_id", res.user_id,{expires:14});
                Cookies.set("login_type", 'student',{expires:14});
                getcommon().then(res => {
                  if(res.apiStatus) {
                    sessionStorage.setItem('studentInfo', JSON.stringify(res))
                  }
                }).catch(e => {
                  this.$message.error(e)
                })
                let data2 = {
                  user_id: res.user_id,
                };
                get_detail(data2).then((res) => {
                  if (res.apiStatus) {
                    sessionStorage.setItem("resume_data", JSON.stringify(res));
                    switch (this.isJump) {
                      case '1':
                        if(this.$route.query.isLogin == '1') {
                          if(res.name) {
                            this.$router.push({ path: "/resume" });
                          } else {
                            this.$router.push({ path: "/resume_create" });
                          }
                        }else {
                          if (res.name) {
                            const {href} = this.$router.resolve({
                              path: '/resume'
                            })
                            if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
                              window.open(href, '_self')
                            } else {
                              window.open(href, '_blank')
                            }
                          } else {
                            const {href} = this.$router.resolve({
                              path: '/resume_create'
                            })
                            if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
                              window.open(href, '_self')
                            } else {
                              window.open(href, '_blank')
                            }
                          }
                        }
                            break
                      case '2':
                        if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
                          window.open(this.videoDetailUrl,'_self')
                        } else {
                          window.open(this.videoDetailUrl, '_blank')
                        }
                            break
                      case '3':  // 职位详情
                      case '4':  // 公司详情
                         this.$parent.handleRefresh();
                            break
                      case '5':  // 投递反馈
                      case '6':  // 我的收藏
                        this.$parent.handleParentRefresh();
                      case '7':  // 职位列表页
                        this.$parent.handlePositionRefresh();
                      case '8': //职位推荐页
                        this.$parent.handlePositionRefreshRecommend()
                        break
                      case '9': // ai智写简历
                        this.$parent.handleAiResume()
                        getcommon().then(res => {
                          if(res.apiStatus) {
                            this.$router.push({path: '/aiResumeBasicInfo'})
                          }
                        }).catch(e => {
                          this.$message.error(e)
                        })
                        break
                      case '10': // ai简历诊断 || 面试
                        this.$parent.handleAiResume()
                        break
                      case '11': // ai简历诊断 || 面试 头部登录成功刷新页面
                        eventBus.$emit('handleInit')
                        break
                    }
                    console.log('window.location',window.location)
                    if(window.location.hash.includes('jobRecommend')){
                      this.$parent.handlePositionRefresh()
                    }
                  }
                });
                this.$emit('closeClick')
                // Cookies.set('user_id', res.data.data.user_id, { expires: 14 })
              } else {
                this.$Message.info({
                  content: res.data.msg,
                });
              }
            });
          }
        });
      },
      getIdentifyCode() {
        this.$refs.loginForm.validateField("phone", (valid) => {
          if (valid === "") {
            this.captchaCheck()
            // this.handleSendCode();
            // this.countDown();
            // this.isShowGetCode = false;
          }
        });
      },
      getcominfos () {
        console.log()
        let data = {
          domain: location.host
        }
        getcominfo(data).then(res => {
          // console.log('res===========',res)
          if (res.apiStatus) {
            this.company_concat_qr_code_url = res.company_concat_qr_code_url
          }
        })
      },
      //验证码登录拖动
      captchaCheck() {
        try {
          let appid = '191672554'
          let captcha = new TencentCaptcha(appid, res => {
            // 用户滑动结束或者关闭弹窗，腾讯返回的内容
            if (res.ret === 0) {
              if (res.errorCode || res.errorMessage) {
                this.errorModal = true
                this.errorMsg = res.errorCode + ': ' + error_code_map[res.errorCode]
                return
              }
              this.handleSendCode( res.appid, res.randstr, res.ticket)
            }
          })
          // 滑块显示
          captcha.show()
        } catch (error) {
          this.errorModal = true
          this.errorMsg = '当前上网环境异常，请更换网络环境或稍后再试'
        }
      },
      countDown() {
        const self = this;
        this.timer = setInterval(() => {
          self.countdown--;
          if (self.countdown === 0) {
            clearInterval(self.timer);
            this.timer = null;
            self.countdown = 60;
            self.isShowGetCode = true;
          }
        }, 1000);
      },

      handleSendCode(appid,randstr,ticket) {
        this.countDown();
        this.isShowGetCode = false;
        let data = {
          phone: this.isChinaTaiWan && this.phone_type == '886' ? this.phone_type + this.form.phone : this.form.phone,
          type: 1,
          captcha_appid: appid,
          captcha_randstr: randstr,
          captcha_ticket: ticket
        };
        sendcode(data).then((res) => {
          if (res.data.msg == "success") {
          } else {
            this.$Message.info({
              content: res.data.msg,
            });
          }
        });
      },
      resetCode() {
        // this.$refs.imgmask.style.opacity = 1;
        this.maskflag = false;
        this.loadingflag = true;
        this.wxloginimg = "";

        this.getwximg();
      },
      aroundquest() {
        if (this.wxloginimg) {
          let data = {
            uuid: this.uuid,
          };

          getloginstatus(data).then((res) => {
            if(!window.isJumpFlag) return   // 防止多次请求  返回成功结果 重复跳转页面
            if (res.user_id) {
              window.isJumpFlag = false
              this.clearCookieData()
              this.$Message.success("登录成功");
              Cookies.set("user_id", res.user_id,{expires:14});
              Cookies.set("login_type", 'student',{expires:14});
              let data2 = {
                user_id: res.user_id,
              };
              getcommon().then(res => {
                if(res.apiStatus) {
                  sessionStorage.setItem('studentInfo', JSON.stringify(res))
                }
              }).catch(e => {
                this.$message.error(e)
              })
              get_detail(data2).then((res) => {
                if (res.apiStatus) {
                  sessionStorage.setItem("resume_data", JSON.stringify(res));
                  switch (this.isJump) {
                    case '1':
                      if(this.$route.query.isLogin == '1') {
                        if(res.name) {
                          this.$router.push({ path: "/resume" });
                        } else {
                          this.$router.push({ path: "/resume_create" });
                        }
                      }else {
                        if (res.name) {
                          const { href } = this.$router.resolve({
                            path: '/resume'
                          })
                          if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
                            window.open(href, '_self')
                          } else {
                            window.open(href, '_blank')
                          }
                        } else {
                          const { href } = this.$router.resolve({
                            path: '/resume_create'
                          })
                          if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
                            window.open(href, '_self')
                          } else {
                            window.open(href, '_blank')
                          }
                        }
                      }
                      break
                    case '2':
                      if (this.browserType == 'QQ' || this.browserType == 'IE' || this.browserType == 'Safari' || this.browserType == 'Firefox') {
                        window.open(this.videoDetailUrl,'_self')
                      } else {
                        window.open(this.videoDetailUrl, '_blank')
                      }
                      break
                    case '3':  // 职位详情
                    case '4':  // 公司详情
                      this.$parent.handleRefresh();
                    case '5':  // 投递反馈
                    case '6':  // 我的收藏
                      this.$parent.handleParentRefresh();
                      break
                    case '5':  // 投递反馈
                    case '6':  // 我的收藏
                      this.$parent.handleParentRefresh();
                      break
                    case '7':  // 职位列表页
                      this.$parent.handlePositionRefresh();
                    case '8': //职位推荐页
                      this.$parent.handlePositionRefreshRecommend()
                      break
                    case '9': // ai智写简历
                      this.$parent.handleAiResume()
                      getcommon().then(res => {
                        if(res.apiStatus) {
                          if ( res && res.has_resume == '1') { // 是否存在 在线简历   0：否；1：是
                            this.$router.push({path: '/aiResumeDetail'})
                          }
                        }
                      }).catch(e => {
                        this.$message.error(e)
                      })
                      break
                    case '10': // ai简历诊断 || ai面试
                      this.$parent.handleAiResume()
                      break
                  }
                }
              });
              this.$emit('closeClick')
            }
          });
        }
      },

      getwximg() {
        let data = {
          page: "pages/pclogin/pclogin",
        };
        getwximg(data).then((res) => {
          this.wxloginimg = res.QRcode;
          this.uuid = res.UUID;
          this.loadingflag = false;

          this.aroundquest();

          let time = 60;

          this.timer = setInterval(() => {
            if (!time) {
              clearInterval(this.timer);
              this.timer = null;
              // this.$refs.imgmask.style.opacity = 0.1;
              this.maskflag = true;
              return;
            }
            setTimeout(this.aroundquest, 0);
            time--;
          }, 1000);
        });
      },

      changelogintype(type) {
        this.logonchangeflag = !this.logonchangeflag;
        if (type == "phone") {
          clearInterval(this.timer);
          this.timer = null;
          this.wxloginimg = "";
        } else {
          this.loadingflag = true;

          this.getwximg();
        }
      },

    },

    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.invoiceModal {
  /deep/ .ivu-modal {
    top: 125px;
  }
  /deep/ .ivu-modal-body {
    padding: 40px 71px;
    text-align: center;
    line-height: 1;
    h4 {
      font-size: 16px;
      color: #ed4112;
    }
    div {
      width: 240px;
      height: 240px;
      padding: 16px;
      margin: 24px auto 0;
      border: 1px solid #eef0f2;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      margin-top: 24px;
      font-size: 14px;
    }
  }
}
  .loginDialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,.6);
    .frombox {
      width: 452px;
      height: 508px;
      background: #ffffff;
      border-radius: 4px;
      position: relative;
      padding-top: 16px;
      box-sizing: border-box;
      .closeBtn {
        width: 36px;
        height: 36px;
        color: rgba(255,255,255,0.8);
        position: absolute;
        right: -36px;
        top: -10px;
        font-size: 34px;
        font-weight: bold;
      }
      .closeBtn:hover {
        cursor: pointer;
        color: rgba(255,255,255,1);
      }
      .fromtop {
        width: 40%;
        cursor:pointer;
        border-radius: 4px;
        display: flex;
        align-items: center;
        padding-left: 16px;
        box-sizing: border-box;
      }

      .erweimaris {
        height: 24px;
        width: 85px;
        background: #ffffff;
        background: url(../../assets/bgc.png) no-repeat center center;
        background-size: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #808695;
        cursor: pointer;
      }
      .frombot {
        padding: 16px 56px 0 56px;
        .img-box {
          height: 240px;
          width: 240px;
          margin: 24px 0 10px 0;
          line-height: 240px;
          text-align: center;
          background-size: 100% 100% !important;
          position: relative;
          .maskdiv {
            line-height: 0;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: rgba(0,0,0,0.6);
            border-radius: 16px;

            .imgs {
              width: 34px;
              height: 34px;
              margin-bottom: 8px;
            }
            .text {
              font-weight: bold;
              font-size: 18px;
              color: #FFFFFF;
              line-height: 31px;
              margin-bottom: 28px;
            }
            .submit {
              width: 124px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 15px;
              bnorder-radius: 3px;
            }
          }
          img {
            width: 110px;
            height: 110px;
            border-radius: 50%;
            vertical-align: middle;
          }
        }
      }
      .botbox {
        display: flex;
        align-items: center;
      }



      .duxinp {
        font-size: 12px;
        color: #808695;
        margin: 16px 0 32px 0;
      }

      .iptbox /deep/ .ivu-input {
        height: 40px;
        width: 100%;
        font-size: 14px;
        display: flex;
        align-items: center;
      }

      /deep/ .iptbox .ivu-form .ivu-form-item-error .ivu-form-item-content{
        .ivu-input:focus {
          box-shadow: none !important;
        }
        .ivu-select-arrow {
          color: #808695;
        }
      }
      /deep/ .iptbox .ivu-form .ivu-form-item .ivu-form-item-content{
        .phone_input {
          .ivu-input {
            border-radius: 4px;
            &:hover {
              border-color: #356ffa;
              box-shadow: none !important;
            }
            &:focus {
              box-shadow: none !important;
              border-color: #356ffa;
            }
          }
        }
        .my_input {
          .ivu-icon-ios-loading {
            display: none;
          }
          .ivu-input {
            border-radius: 0 4px 4px 0;
            &:hover {
              border-color: #356ffa;
              box-shadow: none !important;
            }
          }
          .ivu-input:focus {
            box-shadow: none !important;
            border-color: #356ffa;
          }

          .ivu-input-group-prepend {
            background-color: #fff;

            .ivu-select.ivu-select-single{
              height: 40px;
              border-radius: 4px 0 0 4px;

              .ivu-select-dropdown {
                width: 170px !important;
                padding: 6px 10px;
                box-sizing: border-box;
                box-shadow: none;
                filter: drop-shadow(2px 2px 6px rgba(0, 0, 0, 0.2));

                .ivu-select-dropdown-list {
                  .ivu-select-item {
                    display: flex;
                    justify-content: space-between;

                    &.ivu-select-item-selected {
                      background-color: #fff;
                    }

                    span {
                      font-size: 14px;
                      color: #515A6E;
                      line-height: 19px;
                    }

                    &:first-child {
                      padding: 8px 6px;
                      box-sizing: border-box;
                      border-bottom: 1px solid #F5F5F5;
                    }
                    &:last-child {
                      padding: 8px 6px;
                      box-sizing: border-box;
                    }

                    &:hover {
                      background-color: #fff;
                      span {
                        color: #2F3031 !important;
                      }
                    }
                  }
                }
              }

              .ivu-select-selection {
                height: 40px;
                margin: 0;

                .ivu-select-placeholder, .ivu-select-selected-value {
                  height: 40px;
                  line-height: 40px;
                }
              }
            }
          }
        }
      }

      .iptboxch {
        margin-top: 20px;
        display: flex;
        align-items: center;
        position: relative;
      }

      .iptboxch .ivu-input {
        border-right: 0;
        border-radius: 4px 0 0 4px;
        border-right: 1px solid #fff;
      }

      .getyan {
        width: 111px;
        height: 42px;
        border: 1px solid #dcdee2;
        border-left: 0;
        font-size: 14px;
        color: #3b80fb;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        border-radius: 0 4px 4px 0;
        left: 228px;
        top: 0;
        cursor: pointer;
      }

      //.maskdiv {
      //  height: 240px;
      //  width: 240px;
      //  position: absolute;
      //  top: 20px;
      //  right: 50px;
      //  z-index: 222;
      //  display: flex;
      //  flex-direction: column;
      //  justify-content: center;
      //  align-items: center;
      //}

      /deep/ .sms-wrapper .ivu-form-item-content {
        display: flex;

        .ivu-input-wrapper {
          .ivu-input {
            border-radius: 4px;

            &:hover {
              border-color: #356ffa;
              box-shadow: none !important;
            }
          }
          .ivu-input:focus {
            box-shadow: none !important;
            border-color: #356ffa;
          }
        }
      }
      .identiCode {
        font-size: 14px;
        color: #1477EF;
        position: absolute;
        top: 5px;
        right: 20px;

        &:before {
          content: '';
          border-left: 1px solid #DDDEE3;
          padding-left: 20px;
          box-sizing: border-box;
        }
      }

      .identiCode:hover {
        cursor: pointer;
      }
      .subnitBtn {
        width: 340px;
        height: 44px;
        background-color: #1477EF;
        border-radius: 4px;
        font-size: 16px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          cursor: pointer;
          background-color: #2B84F0;
        }
        &:active {
          cursor: pointer;
          background-color: #116AD6;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/loginDialog.vue